/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InstanceBulkActionExcludedInstance } from './InstanceBulkActionExcludedInstance';
import {
    InstanceBulkActionExcludedInstanceFromJSON,
    InstanceBulkActionExcludedInstanceFromJSONTyped,
    InstanceBulkActionExcludedInstanceToJSON,
    InstanceBulkActionExcludedInstanceToJSONTyped,
} from './InstanceBulkActionExcludedInstance';
import type { InstanceBulkActionLead } from './InstanceBulkActionLead';
import {
    InstanceBulkActionLeadFromJSON,
    InstanceBulkActionLeadFromJSONTyped,
    InstanceBulkActionLeadToJSON,
    InstanceBulkActionLeadToJSONTyped,
} from './InstanceBulkActionLead';

/**
 * 
 * @export
 * @interface InstanceBulkActionCandidatesResponse
 */
export interface InstanceBulkActionCandidatesResponse {
    /**
     * 
     */
    eligible: Array<InstanceBulkActionLead>;
    /**
     * 
     */
    excluded: Array<InstanceBulkActionExcludedInstance>;
}

/**
 * Check if a given object implements the InstanceBulkActionCandidatesResponse interface.
 */
export function instanceOfInstanceBulkActionCandidatesResponse(value: object): value is InstanceBulkActionCandidatesResponse {
    if (!('eligible' in value) || value['eligible'] === undefined) return false;
    if (!('excluded' in value) || value['excluded'] === undefined) return false;
    return true;
}

export function InstanceBulkActionCandidatesResponseFromJSON(json: any): InstanceBulkActionCandidatesResponse {
    return InstanceBulkActionCandidatesResponseFromJSONTyped(json, false);
}

export function InstanceBulkActionCandidatesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstanceBulkActionCandidatesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'eligible': ((json['eligible'] as Array<any>).map(InstanceBulkActionLeadFromJSON)),
        'excluded': ((json['excluded'] as Array<any>).map(InstanceBulkActionExcludedInstanceFromJSON)),
    };
}

export function InstanceBulkActionCandidatesResponseToJSON(json: any): InstanceBulkActionCandidatesResponse {
    return InstanceBulkActionCandidatesResponseToJSONTyped(json, false);
}

export function InstanceBulkActionCandidatesResponseToJSONTyped(value?: InstanceBulkActionCandidatesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'eligible': ((value['eligible'] as Array<any>).map(InstanceBulkActionLeadToJSON)),
        'excluded': ((value['excluded'] as Array<any>).map(InstanceBulkActionExcludedInstanceToJSON)),
    };
}

